import type { Router } from '@angular/router';
import { HttpStatusCode } from '@angular/common/http';
import type { TimesheetService } from '../services/timesheet.service';
import type { PmTimesheetService } from '../../PM_timesheet_view/services/pm-timesheet.service';
import type { SnackbarService } from '../../../services/snack-service/snackbar-service';
import { queryParamMapFromUrl } from './my-timesheet-deep-link.util';
import {
  hasRmTimesheetDeepLinkAttempt,
  parseRmTimesheetDeepLink,
} from './rm-timesheet-deep-link.util';

/**
 * Shared bootstrap for RM approval deep links (guard + shell + RmTimesheetComponent).
 * Sets the shell week first so `ts-topbar` matches, then selects the employee after roster load.
 */
export function applyRmTimesheetDeepLinkFromUrl(
  router: Router,
  timesheetShell: TimesheetService,
  pm: PmTimesheetService,
  url: string,
  snackbar?: SnackbarService,
): boolean {
  if (!url.includes('/timesheet/approval-timsheet')) return false;
  const qp = queryParamMapFromUrl(router, url);
  const deepLink = parseRmTimesheetDeepLink(qp);
  if (deepLink) {
    timesheetShell.setApprovalShellMode(true);
    timesheetShell.switchView('weekly');
    timesheetShell.setAnchorFromCalendar(new Date(`${deepLink.startDate}T12:00:00`));
    pm.bootstrapReportingManagerFromDeepLink(deepLink);
    return true;
  }
  if (hasRmTimesheetDeepLinkAttempt(qp)) {
    snackbar?.show(
      'Invalid link',
      'Timesheet date range in this link is invalid. Showing the current week.',
      HttpStatusCode.BadRequest,
    );
  }
  return false;
}
